import { AbstractPersistentFilter } from './AbstractPersistentFilter.mjs'

export class ExactUrlFilter extends AbstractPersistentFilter {
  static TYPE = 'exact'
  constructor(opts = {}) {
    if (!opts.value) throw new Error('ExactUrlFilter requires a URL value')
    super(ExactUrlFilter.TYPE, opts)
  }
  matches(url) {
    if (!url || !this.value) return false
    return this._normalize(url) === this.value
  }

  /** Assume exclusive **/
  explain(url) {
    if (this.secure) {
      return 'Your settings prevent this URL from being displayed'
    }
    return `${this.value} URLs are filtered out by your settings`
  }

  get simpleLabel() {
    return this.value
  }

  get label() {
    return `URL is exactly “${this.secure ? `[redacted]` : this.value}”`
  }
}
